import { render, staticRenderFns } from "./Referencias.vue?vue&type=template&id=35216e32&scoped=true&lang=html&"
import script from "./Referencias.vue?vue&type=script&lang=js&"
export * from "./Referencias.vue?vue&type=script&lang=js&"
import style0 from "./Referencias.vue?vue&type=style&index=0&id=35216e32&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35216e32",
  null
  
)

export default component.exports